import React from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';

import {rootMainPath, rootAuthPath, mainPath, noFoundPath} from './paths';
import Home from '../features/Home/Home';
import Projects from '../features/Projects/Projects';
import Companies from '../features/Companies/Companies';
import Profile from '../features/Profile/Profile';
import Archive from '../features/Mailing';
import PrivacyPolicy from '../features/PrivacyPolicy';
import {ErrorPage} from '../features/Components/Error';
import Notifications from "../features/Notifications";

const MainRoutes = () => {
  if (!localStorage.token) return <Redirect to={rootAuthPath} />;

  return (
    <Switch>
      <Redirect from={rootMainPath} exact to={mainPath.home} />
      <Route path={mainPath.home} component={Home} />
      <Route path={mainPath.notifications} component={Notifications} />
      <Route path={mainPath.projects} component={Projects} />
      <Route path={mainPath.companies} component={Companies} />
      <Route path={mainPath.profile} component={Profile} />
      <Route path={mainPath.archive} component={Archive} />
      <Route path={mainPath.policy} component={PrivacyPolicy} />
      <Route path={mainPath.error} component={ErrorPage} />
      <Route path={'*'} render={() => <Redirect to={noFoundPath} />} />
    </Switch>
  );
};

export default MainRoutes;
